import React from 'react'

import { Link } from 'react-router-dom'
/// Scroll
import PerfectScrollbar from 'react-perfect-scrollbar'
import Cookies from 'js-cookie'
/// Image
// import profile from "../../images/profile/17,jpg";
import avatar from '../../images/avatar/1.jpg'
import { Dropdown } from 'react-bootstrap'
import callapi from '../../helpers/callapi'

const Header = ({ onNote }) => {
  var path = window.location.pathname.split('/')
  var name = path[path.length - 1].split('-')
  var filterName = name.length >= 3 ? name.filter((n, i) => i > 0) : name
  var finalName = filterName.includes('app')
    ? filterName.filter((f) => f !== 'app')
    : filterName.includes('ui')
      ? filterName.filter((f) => f !== 'ui')
      : filterName.includes('uc')
        ? filterName.filter((f) => f !== 'uc')
        : filterName.includes('basic')
          ? filterName.filter((f) => f !== 'basic')
          : filterName.includes('jquery')
            ? filterName.filter((f) => f !== 'jquery')
            : filterName.includes('table')
              ? filterName.filter((f) => f !== 'table')
              : filterName.includes('page')
                ? filterName.filter((f) => f !== 'page')
                : filterName.includes('email')
                  ? filterName.filter((f) => f !== 'email')
                  : filterName.includes('ecom')
                    ? filterName.filter((f) => f !== 'ecom')
                    : filterName.includes('chart')
                      ? filterName.filter((f) => f !== 'chart')
                      : filterName.includes('editor')
                        ? filterName.filter((f) => f !== 'editor')
                        : filterName
  return (
    <div className="header">
      <div className="header-content">
        <nav className="navbar navbar-expand">
          <div className="collapse navbar-collapse justify-content-between">
            <div className="header-left">
              {/* <div
                className="dashboard_bar"
                style={{ textTransform: "capitalize" }}
              >
                {finalName.join(" ").length === 0
                  ? "dashboard"
                  : finalName.join(" ")}
              </div> */}
            </div>

            <ul className="navbar-nav header-right">
              <Dropdown as="li" className="nav-item dropdown header-profile">
                <div
                  className="dropdown-item ai-icon"
                  style={{ cursor: 'pointer' }}
                  onClick={async () => {
                    try {
                      await callapi({ url: `/orders/unlock` })
                    } catch (err) {
                      console.log(err.message)
                    }
                    Cookies.remove('accessToken')
                    window.location.replace('/page-login')
                  }}
                >
                  <svg
                    id="icon-logout"
                    xmlns="http://www.w3.org/2000/svg"
                    className="text-danger"
                    width={18}
                    height={18}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                    <polyline points="16 17 21 12 16 7" />
                    <line x1={21} y1={12} x2={9} y2={12} />
                  </svg>
                  <span className="ml-2">Logout </span>
                </div>
              </Dropdown>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  )
}

export default Header
